

 <app-summary-vehicle-details></app-summary-vehicle-details>
 <app-summary-windscreen *ngIf="claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_MVA_WINDSCREEN') !== -1"></app-summary-windscreen>
 <app-summary-theft *ngIf="claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_MV_THEFT') !== -1"></app-summary-theft>
 <app-summary-accident-collission *ngIf="claim.getSelectedClaimTypesList().indexOf('CLAIM_TYPE_MVA_COLLISION') !== -1"></app-summary-accident-collission>